import React, {useState} from 'react';
import compose from 'recompose/compose';
import { withI18n } from '../../hocs';
import { ModalStyled } from './styled';
import ActionDialog, { LoadingLabel } from '../action-dialog';
import {CustomAlert, InputField, RegularButton} from '../../atoms';
import { ArrowRight } from 'lucide-react';
import { tokens } from '../../../assets/tokens';
import SelectChangeStatusFunnel from '../../molecules/select-change-status-funnel';
import {useFunnelStatusTypes} from "../../../api/queries/useFunnelStatusTypes";
import { useMutation } from '@tanstack/react-query';
import { moveCandidatesFromStateTo } from '../../../api';
import { timer } from '../../../utils/clock';

const ModalDeleteState = ({ open, handleClose, i18n, onSubmitDelete, item, module }) => {
    const [deleteButtonIsDisabled, setDeleteButtonIsDisabled] = useState(false);
    const [stateCannotBeDeleted, setStateCannotBeDeleted] = useState(false);
    const [usedByCandidatures, setUsedByCandidatures] = useState(null);
    const [statusToReceiveCandidatures, setStatusToReceiveCandidatures] = useState({});
    const { data: statusFunnelTypes, isSuccess } = useFunnelStatusTypes(module);
    let filteredStatusFunnelTypes = [];
    if (isSuccess) {
        filteredStatusFunnelTypes = (statusFunnelTypes?.data ?? []).filter((status) => {
            return item.id != status.id;
        });
    }
    
    const onClickDelete = async e => {
        e.preventDefault();
        setStateCannotBeDeleted(false);
        setUsedByCandidatures(null);
        setStatusToReceiveCandidatures({});

        const response = await onSubmitDelete(item);
        // Si la petición falla, el modal sigue abierto tal cual
        if (!response || response.error) {
            return;
        }
        if (response.hasBeenDeleted === false) {
            setStateCannotBeDeleted(true);
            setDeleteButtonIsDisabled(true);
            setUsedByCandidatures(response.usedByCandidatures);
            return;
        }
        handleClose();
    }

    const mutationMoveCandidatesFromState = useMutation((data) => moveCandidatesFromStateTo({
        module: module,
        data: data
    }));

    const moveCandidatesFromToStates = () => {
        if (mutationMoveCandidatesFromState.isLoading) return;
        mutationMoveCandidatesFromState.mutate(
            {
                current_status: item.id,
                new_status: statusToReceiveCandidatures?.id ?? null,
            },
            {
                onSuccess: () => {
                    setStateCannotBeDeleted(false);
                    setDeleteButtonIsDisabled(false);
                },
                onError: (error) => {
                    // eslint-disable-next-line no-console
                    console.error("Error during delete:", error);
                }
            }
        );
    }

    return (
        <ActionDialog
            open={open}
            title={i18n.phases_states.modalDeleteStateTitle}
            onClose={handleClose}
            onConfirm={onClickDelete}
            cancelLabel={i18n.phases_states.buttonCancel}
            confirmLabel={i18n.phases_states.buttonDelete}
            confirmColor="error"
            confirmDisabled={deleteButtonIsDisabled}
            maxWidth="sm"
            fullWidth
        >
            <ModalStyled>
                {usedByCandidatures && timer(12000, () => setUsedByCandidatures(null)) && <CustomAlert severity="error" message={i18n.phases_states.errorOnDeleteStatus.replace('{candidatures}', usedByCandidatures)} />}
                <form>
                    {/* Si el estado tiene candidaturas, en la misma fila: actual → nuevo + Mover */}
                    <div className={stateCannotBeDeleted ? 'moveRow' : ''}>
                        <div className="formField">
                            <label>{i18n.phases_states.labelCurrentState}</label>
                            <InputField placeholder={i18n.phases_states.placeholderPhase} value={item.name} disabled />
                        </div>
                        {stateCannotBeDeleted ? (
                            <>
                                <span className="moveArrow">
                                    <ArrowRight size={20} color={tokens.color.text.secondary} />
                                </span>
                                <div className="formField">
                                    <label>{i18n.phases_states.labelNewState}</label>
                                    <SelectChangeStatusFunnel options={filteredStatusFunnelTypes} label={false} onSelectedItemChange={(newStatus) => setStatusToReceiveCandidatures(newStatus)} />
                                </div>
                                <RegularButton type="button" title={<LoadingLabel loading={mutationMoveCandidatesFromState.isLoading}>{i18n.phases_states.buttonMove}</LoadingLabel>} onClick={() => moveCandidatesFromToStates()} />
                            </>
                        ) : '' }
                    </div>
                </form>
            </ModalStyled>
        </ActionDialog>
    )
}

const enhance = compose(withI18n);

export default enhance(ModalDeleteState);
